import React from 'react';
import { GridOverlay } from '@mui/x-data-grid-pro';
import { ReactComponent as EmptyTruckIcon } from 'assets/icons/empty-truck.svg';

interface Props {
  clearFilters: () => void;
  variant: 'containers' | 'shipments';
  className?: string;
}

export const NoneFoundOverlay: React.FC<Props> = (props) => {
  // TODO: Fix this
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { clearFilters, variant, className } = props;
  return (
    <GridOverlay className={className}>
      <div className="flex flex-col p-4 space-y-4 items-center" style={{ zIndex: 1099 }}>
        <EmptyTruckIcon />
        <div className="flex flex-col items-center">
          <h3 className="text-dark">No tracked {variant} match these filters.</h3>
          {/* <h3 className="text-blue-900 underline cursor-pointer" onClick={clearFilters}>
            Reset filters
          </h3> */}
        </div>
      </div>
    </GridOverlay>
  );
};
NoneFoundOverlay.displayName = 'ContainerTable.NoneFoundOverlay';
